import { put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { InsighttNotification } from '../../helpers/insightt-notification';
import ShiftActions from '../actions/shift.actions';
import { SHIFT_TYPES } from '../../constants/app.constants';

export function* getShiftStatusRequest(api) {
  const response = yield api.getShiftStatus();
  if (response && response.ok) {
    yield put(ShiftActions.getShiftStatusSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get your shift status', response);
    yield put(ShiftActions.getShiftStatusFailure());
  }
}

export function* startShiftRequest(api, action) {
  const { shiftType, shiftId, payload } = action;
  const response = yield api.startShift(shiftType, shiftId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Shift started successfully');
    yield put(ShiftActions.startShiftSuccess(response.data));
    if (shiftType === SHIFT_TYPES.normal_shift) {
      yield put(push('/app/shift/dashboard'));
    }
  } else {
    InsighttNotification('error', 'Unable to start shift', response);
    yield put(ShiftActions.startShiftFailure());
  }
}

export function* pauseShiftRequest(api, action) {
  const { shiftTimeId, payload } = action;
  const response = yield api.pauseShift(shiftTimeId, payload);
  if (response && response.ok) {
    const pauseTimeId = response.data.id;
    const pauseStartTime = response.data.startTime;
    yield put(ShiftActions.pauseShiftSuccess(pauseTimeId, pauseStartTime));
  } else {
    InsighttNotification('error', 'Unable to pause shift', response);
    yield put(ShiftActions.pauseShiftFailure());
  }
}

export function* resumeShiftRequest(api, action) {
  const { shiftTimeId, payload } = action;
  const response = yield api.resumeShift(shiftTimeId, payload);
  if (response && response.ok) {
    yield put(ShiftActions.resumeShiftSuccess(response.data.totalPauseTimes));
  } else {
    yield put(ShiftActions.resumeShiftFailure());
  }
}

export function* takeBreakRequest(api, action) {
  const { shiftTimeId, startedBreak, payload } = action;
  const response = yield api.takeBreak(shiftTimeId, startedBreak.id, payload);
  if (response && response.ok) {
    const breakTimeId = response.data.id;
    yield put(ShiftActions.takeBreakSuccess(breakTimeId, startedBreak));
  } else {
    InsighttNotification('error', 'Unable to take break', response);
    yield put(ShiftActions.takeBreakFailure(startedBreak));
  }
}

export function* endBreakRequest(api, action) {
  const { shiftTimeId, breakId, payload } = action;
  const response = yield api.endBreak(shiftTimeId, 0, payload);
  if (response && response.ok) {
    yield put(ShiftActions.endBreakSuccess(breakId));
    InsighttNotification('success', 'Your break has ended successfully');
  } else {
    yield put(ShiftActions.endBreakFailure());
  }
}

export function* trackLocationRequest(api, action) {
  const { shiftTimeId, payload } = action;
  const response = yield api.trackLocation(shiftTimeId, payload);
  if (response && response.ok) {
    yield put(ShiftActions.trackLocationSuccess(response.data));
  } else {
    yield put(ShiftActions.trackLocationFailure());
  }
}

export function* endShiftRequest(api, action) {
  const { shiftTimeId, payload } = action;
  const response = yield api.endShift(shiftTimeId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Shift ended successfully');
    yield put(ShiftActions.endShiftSuccess());
  } else {
    InsighttNotification('error', 'Unable to end shift', response);
    yield put(ShiftActions.endShiftFailure());
  }
}

export function* getShiftRepossessionsOverviewRequest(api, action) {
  const response = yield api.getShiftRepossessionsOverview(action.shiftTimeId);
  if (response && response.ok) {
    yield put(ShiftActions.getShiftRepossessionsOverviewSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get shift repossessions data', response);
    yield put(ShiftActions.getShiftRepossessionsOverviewFailure());
  }
}

export function* getShiftRepossessionsGoalsRequest(api, action) {
  const response = yield api.getShiftRepossessionsGoals(action.shiftId);
  if (response && response.ok) {
    yield put(ShiftActions.getShiftRepossessionsGoalsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get shift repossessions goals', response);
    yield put(ShiftActions.getShiftRepossessionsGoalsFailure());
  }
}

export function* getShiftRepossessionsHitListRequest(api, action) {
  const response = yield api.getShiftRepossessionsHitList(action.branchId);
  if (response && response.ok) {
    yield put(ShiftActions.getShiftRepossessionsHitListSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get shift repossession hit list', response);
    yield put(ShiftActions.getShiftRepossessionsHitListFailure());
  }
}

export function* getSpottedVehicleByVinRequest(api, action) {
  const { shiftTimeId, vin } = action;
  const response = yield api.getSpottedVehicleByVin(shiftTimeId, vin);
  if (response && response.ok) {
    yield put(ShiftActions.getSpottedVehicleByVinSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get case by vin', response);
    yield put(ShiftActions.getSpottedVehicleByVinFailure());
  }
}

export function* submitSpottedVehicleRequest(api, action) {
  const { shiftTimeId, payload } = action;
  const response = yield api.submitSpottedVehicle(shiftTimeId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'The vehicle was spotted successfully', response);
    yield put(ShiftActions.submitSpottedVehicleSuccess());
  } else {
    InsighttNotification('error', 'Unable to spott vehicle', response);
    yield put(ShiftActions.submitSpottedVehicleFailure());
  }
}

export function* submitCustomCommissionRequest(api, action) {
  const { payload } = action;
  const response = yield api.submitCustomCommission(payload);
  if (response && response.ok) {
    InsighttNotification('success', 'You request for custom commission was submitted successfully', response);
    yield put(ShiftActions.submitCustomCommissionSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to request custom commission', response);
    yield put(ShiftActions.submitCustomCommissionFailure());
  }
}

export function* getCustomCommissionsRequest(api) {
  const response = yield api.getCustomCommissions();
  if (response && response.ok) {
    yield put(ShiftActions.getCustomCommissionsSuccess(response.data));
  } else {
    yield put(ShiftActions.getCustomCommissionsFailure());
  }
}

export function* updateCustomCommissionRequest(api, action) {
  const { commissionId, payload } = action;
  const response = yield api.updateCustomCommission(commissionId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'You request for custom commission was updated successfully', response);
    yield put(ShiftActions.updateCustomCommissionSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to update custom commission', response);
    yield put(ShiftActions.updateCustomCommissionFailure(commissionId));
  }
}

export function* cancelCustomCommissionRequest(api, action) {
  const { commissionId } = action;
  const response = yield api.cancelCustomCommission(commissionId);
  if (response && response.ok) {
    InsighttNotification('success', 'You request for custom commission was cancelled successfully', response);
    yield put(ShiftActions.cancelCustomCommissionSuccess(commissionId));
  } else {
    InsighttNotification('error', 'Unable to cancel custom commission', response);
    yield put(ShiftActions.cancelCustomCommissionFailure(commissionId));
  }
}

export function* getShiftInfractionsRequest(api, action) {
  const { shiftTimeId } = action;
  const response = yield api.getShiftInfractions(shiftTimeId);
  if (response && response.ok) {
    yield put(ShiftActions.getShiftInfractionsSuccess(response.data));
  } else {
    yield put(ShiftActions.getShiftInfractionsFailure());
  }
}

export function* getShiftPendingInfractionsRequest(api, action) {
  const { shiftTimeId } = action;
  const response = yield api.getShiftPendingInfractions(shiftTimeId);
  if (response && response.ok) {
    yield put(ShiftActions.getShiftPendingInfractionsSuccess(response.data));
  } else {
    yield put(ShiftActions.getShiftPendingInfractionsFailure());
  }
}

export function* submitInfractionAnswerRequest(api, action) {
  const { breakId, payload } = action;
  const response = yield api.answerInfraction(breakId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Explanation for an infraction was submitted successfully', response);
    yield put(ShiftActions.submitInfractionAnswerSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to submit an explanation for infraction', response);
    yield put(ShiftActions.submitInfractionAnswerFailure());
  }
}
